<template>
  <v-snackbar
      v-model="toast.show"
      :color="toast.color"
      :timeout="toast.timeout"
      location="top"
  >
    <div class="d-flex align-center">
      <v-icon :icon="toast.icon" class="mr-2" />
      {{ toast.message }}
    </div>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toast } = useToast()
</script> 